export default "__VITE_ASSET__75788009__"